import "../styles/about.css";
import profile from "../images/about.jpg";

import { BiBriefcase, BiAward } from "react-icons/bi";
import { HiUserGroup } from "react-icons/hi";

export default function AboutPage() {
	// Function to navigate between page
	function goTo(elementId) {
		var element = document.getElementById(elementId);
		element.scrollIntoView({
			block: "start",
			behavior: "smooth",
		});
	}

	return (
		<section className="about section" id="about">
			<span className="section__subtitle">My Intro</span>
			<h2 className="section__title">About Me</h2>
			<div className="about__container container">
				<img src={profile} alt="" className="about__img" />

				<div className="about__data">
					<div className="about__info">
						<div className="about__box">
							<BiAward className="about__icon" />
							<h3 className="about__title">Experience</h3>
							<span className="about__subtitle">2+ Years</span>
						</div>

						<div className="about__box">
							<BiBriefcase className="about__icon" />
							<h3 className="about__title">Completed</h3>
							<span className="about__subtitle">5+ Projects</span>
						</div>

						<div className="about__box">
							<HiUserGroup className="about__icon" />
							<h3 className="about__title">More than</h3>
							<span className="about__subtitle">3+ Happy Clients</span>
						</div>
					</div>

					<p className="about__description">
						FullStack developer, creating endpoint deployable applications with
						high scalability. Experienced with MERN Stack, Flutter, React
						Native, C++, Python, C, JavaScript, java and more...
					</p>

					<button onClick={() => goTo("contact")} className="btn">
						Contact Me
					</button>
				</div>
			</div>
		</section>
	);
}
